import { lazy } from 'react';


// Admin imports
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/AdminDashboard'));
const AdminOrder = lazy(() => import('../pages/admin/order/AdminOrder'));
const AdminProduction = lazy(() => import('../pages/admin/production/AdminProduction'));
const AdminInventory = lazy(() => import('../pages/admin/inventory/AdminInventory'));
const AdminStorage = lazy(() => import('../pages/admin/storage/AdminStorage'));
const AdminQCReports = lazy(() => import('../pages/admin/qc-reports/AdminQCReports'));
const Notification = lazy(() => import('../pages/common/notification/Notification'));
const AdminSettings = lazy(() => import('../pages/admin/settings/AdminSettings'));

// Sales Executive imports
const SalesExecutiveDashboard = lazy(() => import('../pages/sales-executive/dashboard/SalesExecutiveDashboard'));
const SalesExecutiveSettings = lazy(() => import('../pages/sales-executive/settings/SalesExecutiveSettings'));
const SalesExecutiveOrder = lazy(() => import('../pages/sales-executive/order/SalesExecutiveOrder'));
const SalesExecutiveCreateSalesOrder = lazy(() => import('../pages/sales-executive/order/SalesExecutiveCreateSalesOrder'));
const SalesExecutiveOrderDetails = lazy(() => import('../pages/sales-executive/order/SalesExecutiveOrderDetails'));
const SalesExecutiveCustomers = lazy(() => import('../pages/sales-executive/customers/SalesExecutiveCustomers'));
const SalesExecutiveInventory = lazy(() => import('../pages/sales-executive/inventory/SalesExecutiveInventory'));

// Warehouse Manager imports
const WarehouseManagerHome = lazy(() => import('../pages/warehouse-manager/home/WarehouseManagerHome'));
const WarehouseManagerRackMap = lazy(() => import('../pages/warehouse-manager/rack-map/WarehouseManagerRackMap'));
const WarehouseManagerInventory = lazy(() => import('../pages/warehouse-manager/inventory/WarehouseManagerInventory'));
const WarehouseManagerSettings = lazy(() => import('../pages/warehouse-manager/settings/WarehouseManagerSettings'));

// Purchase Head imports
const PurchaseHeadDashboard = lazy(() => import('../pages/purchase-head/dashboard/PurchaseHeadDashboard'));
const PurchaseHeadSettings = lazy(() => import('../pages/purchase-head/settings/PurchaseHeadSettings'));
const PurchaseHeadPurchaseOrders = lazy(() => import('../pages/purchase-head/purchase-orders/PurchaseHeadPurchaseOrders'));
const PurchaseHeadPurchaseOrderDetails = lazy(() => import('../pages/purchase-head/purchase-orders/PurchaseHeadPurchaseOrderDetails'));
const PurchaseHeadPickupInventory = lazy(() => import('../pages/purchase-head/pickup-inventory/PurchaseHeadPickupInventory'));
const PurchaseHeadRawMaterialRequests = lazy(() => import('../pages/purchase-head/raw-material-requests/PurchaseHeadRawMaterialRequests'));

// Farm Purchase Manager imports
const FarmPurchaseManagerDashboard = lazy(() => import('../pages/farm-purchase-manager/dashboard/FarmPurchaseManagerDashboard'));
const FarmPurchaseManagerOrders = lazy(() => import('../pages/farm-purchase-manager/orders/FarmPurchaseManagerOrders'));
const FarmPurchaseManagerAllSupervisors = lazy(() => import('../pages/farm-purchase-manager/all-supervisors/FarmPurchaseManagerAllSupervisors'));
const FarmPurchaseManagerSupervisorDetails = lazy(() => import('../pages/farm-purchase-manager/all-supervisors/FarmPurchaseManagerSupervisorDetails'));
const FarmPurchaseManagerVehicles = lazy(() => import('../pages/farm-purchase-manager/vehicles/FarmPurchaseManagerVehicles'));
const FarmPurchaseManagerSettings = lazy(() => import('../pages/farm-purchase-manager/settings/FarmPurchaseManagerSettings'));

// Farm Supervisor imports
const FarmSupervisorDashboard = lazy(() => import('../pages/farm-supervisor/dashboard/FarmSupervisorDashboard'));
const FarmSupervisorPickupRequests = lazy(() => import('../pages/farm-supervisor/pickup-requests/FarmSupervisorPickupRequests'));
const FarmSupervisorSettings = lazy(() => import('../pages/farm-supervisor/settings/FarmSupervisorSettings'));

// Receiving Manager imports
const ReceivingManagerDashboard = lazy(() => import('../pages/receiving-manager/dashboard/ReceivingManagerDashboard'));
const ReceivingManagerMaterialRequests = lazy(() => import('../pages/receiving-manager/material-requests/ReceivingManagerMaterialRequests'));
const ReceivingManagerInventory = lazy(() => import('../pages/receiving-manager/inventory/ReceivingManagerInventory'));
const ReceivingManagerSettings = lazy(() => import('../pages/receiving-manager/settings/ReceivingManagerSettings'));

// QC Manager imports
const QCManagerDashboard = lazy(() => import('../pages/qc-manager/dashboard/QCManagerDashboard'));
const QCManagerAllQC = lazy(() => import('../pages/qc-manager/all-qc/QCManagerAllQC'));
const QCManagerQCExecutives = lazy(() => import('../pages/qc-manager/qc-executives/QCManagerQCExecutives'));
const QCManagerQCExecutiveDetails = lazy(() => import('../pages/qc-manager/qc-executives/QCManagerQCExecutiveDetails'));
const QCManagerSettings = lazy(() => import('../pages/qc-manager/settings/QCManagerSettings'));

// Production Manager imports
const ProductionManagerDashboard = lazy(() => import('../pages/production-manager/dashboard/ProductionManagerDashboard'));
const ProductionManagerProductionLots = lazy(() => import('../pages/production-manager/production-lots/ProductionManagerProductionLots'));
const ProductionManagerOrders = lazy(() => import('../pages/production-manager/orders/ProductionManagerOrders'));
const ProductionManagerOrderDetails = lazy(() => import('../pages/production-manager/orders/modals/ProductionManagerOrderDetails'))
const ProductionManagerAvailableStock = lazy(() => import('../pages/production-manager/available-stock/ProductionManagerAvailableStock'));
const ProductionManagerRejectedStock = lazy(() => import('../pages/production-manager/rejected-stocks/ProductionManagerRejectedStock'));
//const ProductionManagerWastageStock = lazy(() => import('../pages/production-manager/wastage-stock/ProductionManagerWastageStock'));
const ProductionManagerSettings = lazy(() => import('../pages/production-manager/settings/ProductionManagerSettings'));

// Packaging Supervisor imports
const PackagingSupervisorDashboard = lazy(() => import('../pages/packaging-supervisor/dashboard/PackagingSupervisorDashboard'));
const PackagingSupervisorPackaging = lazy(() => import('../pages/packaging-supervisor/packaging/PackagingSupervisorPackaging'));
const PackagingSupervisorSettings = lazy(() => import('../pages/packaging-supervisor/settings/PackagingSupervisorSettings'));

// Dispatch Executive imports
const DispatchExecutiveDashboard = lazy(() => import('../pages/dispatch-executive/dashboard/DispatchExecutiveDashboard'));
const DispatchExecutiveSettings = lazy(() => import('../pages/dispatch-executive/settings/DispatchExecutiveSettings'));

// Factory Purchase Manager imports
const FactoryPurchaseManagerDashboard = lazy(() => import('../pages/factory-purchase-manager/dashboard/FactoryPurchaseManagerDashboard'));
const FactoryPurchaseManagerInventory = lazy(() => import('../pages/factory-purchase-manager/inventory/FactoryPurchaseManagerInventory'));
const FactoryPurchaseManagerApprovedRequests = lazy(() => import('../pages/factory-purchase-manager/approved-requests/FactoryPurchaseManagerApprovedRequests'));
const FactoryPurchaseManagerSettings = lazy(() => import('../pages/factory-purchase-manager/settings/FactoryPurchaseManagerSettings'));

// Gatekeeper imports
const GatekeeperDashboard = lazy(() => import('../pages/gatekeeper/dashboard/GatekeeperDashboard'));
const GatekeeperSettings = lazy(() => import('../pages/gatekeeper/settings/GatekeeperSettings'));

// QC Executive imports
const QCExecutiveDashboard = lazy(() => import('../pages/qc-executive/dashboard/QCExecutiveDashboard'));
const QCExecutiveAllQC = lazy(() => import('../pages/qc-executive/all-qc/QCExecutiveAllQC'));
const QCExecutiveSettings = lazy(() => import('../pages/qc-executive/settings/QCExecutiveSettings'));
const QCExecutiveSamples = lazy(() => import('../pages/qc-executive/samples/QCExecutiveSamples'));


export const AdminRoutes = [
    { path: '', element: <AdminDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <AdminDashboard />, title: "Dashboard" },
    { path: 'order', element: <AdminOrder />, title: "Order" },
    { path: 'sales-orders/:orderId', element: <SalesExecutiveOrderDetails />, title: 'Sales Order Details' },
    { path: 'production-orders/:orderId', element: <ProductionManagerOrderDetails />, title: "Production Order Details" },
    { path: 'purchase-orders/:orderId', element: <PurchaseHeadPurchaseOrderDetails />, title: "Purchase Order Details" },
    { path: 'production', element: <AdminProduction />, title: "Production" },
    { path: 'inventory', element: <AdminInventory />, title: "Inventory" },
    { path: 'storage', element: <AdminStorage />, title: "Storage" },
    { path: 'qc-reports', element: <AdminQCReports />, title: "QC Reports" },
    { path: 'notification', element: <Notification />, title: "Notifications" },
    { path: 'settings', element: <AdminSettings />, title: "Setting" },
];

export const SalesExecutiveRoutes = [
    { path: '', element: <SalesExecutiveDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <SalesExecutiveDashboard />, title: "Dashboard" },
    { path: 'sales-orders', element: <SalesExecutiveOrder />, title: "Orders" },
    { path: 'sales-orders/create-sales-order', element: <SalesExecutiveCreateSalesOrder />, title: 'Create Sales Order' },
    { path: 'sales-orders/:orderId', element: <SalesExecutiveOrderDetails />, title: 'Order Details' },
    { path: 'customers', element: <SalesExecutiveCustomers />, title: "Customers" },
    { path: 'inventory', element: <SalesExecutiveInventory />, title: "Inventory" },
    { path: 'settings', element: <SalesExecutiveSettings />, title: "Setting" },
];

export const warehouseManagerRoutes = [
    { path: '', element: <WarehouseManagerHome />, title: "Home" },
    { path: 'dashboard', element: <WarehouseManagerHome />, title: "Home" },
    { path: 'rack-map', element: <WarehouseManagerRackMap />, title: "Rack Map" },
    { path: 'inventory', element: <WarehouseManagerInventory />, title: "Inventory" },
    { path: 'settings', element: <WarehouseManagerSettings />, title: "Settings" },
];

export const PurchaseHeadRoutes = [
    { path: '', element: <PurchaseHeadDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <PurchaseHeadDashboard />, title: "Dashboard" },
    { path: 'settings', element: <PurchaseHeadSettings />, title: "Settings" },
    { path: 'purchase-orders', element: <PurchaseHeadPurchaseOrders />, title: 'Purchase Orders' },
    { path: 'purchase-orders/:orderId', element: <PurchaseHeadPurchaseOrderDetails />, title: 'Order Details' },
    { path: 'pickup-inventory', element: <PurchaseHeadPickupInventory />, title: 'Pickup Inventory' },
    { path: 'raw-material-requests', element: <PurchaseHeadRawMaterialRequests />, title: 'Raw Material Requests' },
    { path: 'settings', element: <PurchaseHeadSettings />, title: "Settings" },
];

export const FarmPurchaseManagerRoutes = [
    { path: '', element: <FarmPurchaseManagerDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <FarmPurchaseManagerDashboard />, title: "Dashboard" },
    { path: 'orders', element: <FarmPurchaseManagerOrders />, title: "Orders" },
    { path: 'all-supervisors', element: <FarmPurchaseManagerAllSupervisors />, title: "All Supervisors" },
    { path: 'all-supervisors/:supervisorId', element: <FarmPurchaseManagerSupervisorDetails />, title: 'Supervisor Details' },
    { path: 'vehicles', element: <FarmPurchaseManagerVehicles />, title: "Vehicles" },
    { path: 'settings', element: <FarmPurchaseManagerSettings />, title: "Settings" },
];

export const FarmSupervisorRoutes = [
    { path: '', element: <FarmSupervisorDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <FarmSupervisorDashboard />, title: "Dashboard" },
    { path: 'pickup-requests', element: <FarmSupervisorPickupRequests />, title: "Pickup Requests" },
    { path: 'settings', element: <FarmSupervisorSettings />, title: "Settings" },
];

export const ReceivingManagerRoutes = [
    { path: '', element: <ReceivingManagerDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <ReceivingManagerDashboard />, title: "Dashboard" },
    { path: 'material-requests', element: <ReceivingManagerMaterialRequests />, title: "Material Requests" },
    { path: 'inventory', element: <ReceivingManagerInventory />, title: "Inventory" },
    { path: 'settings', element: <ReceivingManagerSettings />, title: "Settings" },
];

export const QCManagerRoutes = [
    { path: '', element: <QCManagerDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <QCManagerDashboard />, title: "Dashboard" },
    { path: 'all-qc', element: <QCManagerAllQC />, title: "All QC" },
    { path: 'qc-executives', element: <QCManagerQCExecutives />, title: "QC Executives" },
    { path: 'qc-executives/:id', element: <QCManagerQCExecutiveDetails />, title: "QC Executive Details" },
    { path: 'settings', element: <QCManagerSettings />, title: "Settings" },
];

export const ProductionManagerRoutes = [
    { path: '', element: <ProductionManagerDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <ProductionManagerDashboard />, title: "Dashboard" },
    { path: 'production-lots', element: <ProductionManagerProductionLots />, title: "Production Lots" },
    { path: 'orders', element: <ProductionManagerOrders />, title: "Orders" },
    { path: 'production-orders/:orderId', element: <ProductionManagerOrderDetails />, title: "Details" },
    { path: 'available-stock', element: <ProductionManagerAvailableStock />, title: "Available Stock" },
    { path: 'rejected-stock', element: <ProductionManagerRejectedStock />, title: "Rejected Stock" },
    // { path: 'wastage-stock', element: <ProductionManagerWastageStock />, title: "Wastage Stock " },
    { path: 'settings', element: <ProductionManagerSettings />, title: "Settings" },
];

export const PackagingSupervisorRoutes = [
    { path: '', element: <PackagingSupervisorDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <PackagingSupervisorDashboard />, title: "Dashboard" },
    { path: 'packaging', element: <PackagingSupervisorPackaging />, title: "Packaging" },
    { path: 'settings', element: <PackagingSupervisorSettings />, title: "Settings" },
];

export const FactoryPurchaseManagerRoutes = [
    { path: '', element: <FactoryPurchaseManagerDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <FactoryPurchaseManagerDashboard />, title: "Dashboard" },
    { path: 'inventory', element: <FactoryPurchaseManagerInventory />, title: "Inventory" },
    { path: 'approved-requests', element: <FactoryPurchaseManagerApprovedRequests />, title: "Approved Requests" },
    { path: 'settings', element: <FactoryPurchaseManagerSettings />, title: "Settings" },
];

export const DispatchExecutiveRoutes = [
    { path: '', element: <DispatchExecutiveDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <DispatchExecutiveDashboard />, title: "Dashboard" },
    { path: 'settings', element: <DispatchExecutiveSettings />, title: "Settings" },
];

export const GatekeeperRoutes = [
    { path: '', element: <GatekeeperDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <GatekeeperDashboard />, title: "Dashboard" },
    { path: 'settings', element: <GatekeeperSettings />, title: "Settings" },
];

export const QCExecutiveRoutes = [
    { path: '', element: <QCExecutiveDashboard />, title: "Dashboard" },
    { path: 'dashboard', element: <QCExecutiveDashboard />, title: "Dashboard" },
    { path: 'all-qc', element: <QCExecutiveAllQC />, title: "All QC" },
    { path: 'all-qc/samples/:taskId', element: <QCExecutiveSamples />, title: "Samples" },
    { path: 'settings', element: <QCExecutiveSettings />, title: "Settings" },
];